import Message from "./Message";

/**
 * Class holds array of chat {@link Message}
 * @class Messages
 */
class Messages {
    messages: any[];
    
    constructor() {
        /**
         *
         * @type {Array.<Message>}
         */
        this.messages = [];
    }

    /**
     * Adding a new message to the Messages array, this will kick in the @see {@link UIRender} engine to display the bubble
     * @param {Message} message
     */
    add(message) {
        if (message instanceof Message) {
            this.messages.push(message);
            this.onItemAdded(this.messages.length - 1);
        }
    }

    onItemAdded(arg0: number) {
        throw new Error("Method not implemented.");
    }

    /**
     * @return {Array.<Message>}
     */
    getMessages() {
        return this.messages;
    }

    /**
     * @return {number}
     */
    size() {
        return this.messages.length;
    }

    /**
     * @param {number} pos
     * @return {Message|null}
     */
    get(pos) {
        return this.messages.length > pos ? this.messages[pos] : null;
    }

    /**
     * @return {boolean}
     */
    hasMessages() {
        return this.messages.length > 0;
    }

    /**
     * This method will kick in @see {@link UIRender} engine to display the bubble at the last or at the given position
     * @param {number}  pos
     * @param {Message} message
     * @return {number | void}
     */
    set(pos, message) {
        if (message instanceof Message) {
            if (this.messages.length > pos) {
                this.messages.splice(pos, 0, message);
                this.onItemSet(pos, message);
                return pos;
            }

            this.messages.push(message);
            this.onItemAdded(this.messages.length - 1);
            return this.messages.length;
        }
        return null;
    }

    onItemSet(pos: any, message: Message) {
        throw new Error("Method not implemented.");
    }

    /**
     * @param {number} pos
     * @param {Message} message
     */
    update(pos, message) {
        if (message instanceof Message) {
            if (this.messages.length > pos) {
                this.messages[pos] = message;
                this.onItemReload(pos, message);
            }
        }
    }

    onItemReload(pos: any, message: Message) {
        throw new Error("Method not implemented.");
    }

    /**
     * This method will kick in @see {@link UIRender} engine to delete the bubble at the given position
     * @param {number} pos
     */
    delete(pos) {
        if (this.messages.length > pos) {
            const msg = this.messages.splice(pos, 1);
            this.onItemDeleted(msg);
        }
    }

    onItemDeleted(msg: any) {
        throw new Error("Method not implemented.");
    }
}

export default Messages;
